import React from "react";
import PropTypes from "prop-types";
import "./articleInfo.scss";
import {
  getAuthorName,
  formatReadingTime,
} from "./articleInfo.helper";
import {
  ARTICLE_INFO_TYPE,
  ARTICLE_INFO_TYPE_CLASS,
  INFO_ITEM_TYPE,
} from "./articleInfo.constants";

const Author = ({ articleAuthor }) => (
  <>
    <span className="author-prefix">by </span>
    <span>{getAuthorName(articleAuthor)}</span>
  </>
);
const ReadingTime = ({ readingTime, className }) => (
  <span className={`reading-time ${className || ""}`}>
    {formatReadingTime(readingTime)}
  </span>
);

const InfoItemSeparator = ({ mobileSeparator }) => {
  return <li className={`dot ${mobileSeparator}`}></li>;
};

const ArticleInfoItem = ({
  children,
  mobileSeparator,
  index,
  isLastIndex,
}) => {
  return (
    <>
      {index % 2 !== 0 && (
        <InfoItemSeparator
          mobileSeparator={mobileSeparator}
        />
      )}
      <li className="item">{children}</li>
      {index % 2 !== 0 && !isLastIndex && (
        <InfoItemSeparator
          mobileSeparator={mobileSeparator}
        />
      )}
    </>
  );
};

const ArticleInfo = ({
  articleAuthor,
  publishDate,
  readingTime,
  articleInfoType,
}) => {
  const titleInfoItems = [
    {
      id: 1,
      itemType: INFO_ITEM_TYPE.AUTHOR,
      children: <Author articleAuthor={articleAuthor} />,
    },
    {
      id: 2,
      itemType: INFO_ITEM_TYPE.READING_TIME_DESKTOP,
      children: (
        <ReadingTime
          readingTime={readingTime}
          className={INFO_ITEM_TYPE.READING_TIME_DESKTOP}
        />
      ),
    },
    {
      id: 3,
      itemType: INFO_ITEM_TYPE.PUBLISHED_DATE,
      children: <span>{publishDate}</span>,
    },
  ];
  const commonInfoItems = [
    {
      id: 1,
      itemType: INFO_ITEM_TYPE.READING_TIME_DESKTOP,
      children: <ReadingTime readingTime={readingTime} />,
    },
    {
      id: 2,
      itemType: INFO_ITEM_TYPE.PUBLISHED_DATE,
      children: publishDate,
    },
  ];
  const infoItemsArray =
    articleInfoType === ARTICLE_INFO_TYPE.TITLE
      ? titleInfoItems
      : commonInfoItems;
  return (
    <>
      <div
        className={`article-info-wrap ${ARTICLE_INFO_TYPE_CLASS[articleInfoType]}`}
      >
        <ul
          className={`article-info ${ARTICLE_INFO_TYPE_CLASS[articleInfoType]}`}
        >
          {infoItemsArray.map((item, index) => (
            <ArticleInfoItem
              key={item.id}
              index={index}
              mobileSeparator={articleInfoType}
              isLastIndex={
                index === infoItemsArray.length - 1
              }
            >
              {item.children}
            </ArticleInfoItem>
          ))}
        </ul>
        {articleInfoType === ARTICLE_INFO_TYPE.TITLE && (
          <ReadingTime
            readingTime={readingTime}
            className={"reading-time mobile"}
          />
        )}
      </div>
      {articleInfoType === ARTICLE_INFO_TYPE.TITLE && (
        <div className="mobile-separator"></div>
      )}
    </>
  );
};

Author.propTypes = {
  articleAuthor: PropTypes.object,
};

ReadingTime.propTypes = {
  readingTime: PropTypes.number,
  className: PropTypes.string,
};

InfoItemSeparator.propTypes = {
  mobileSeparator: PropTypes.string,
};

ArticleInfoItem.propTypes = {
  children: PropTypes.element,
  mobileSeparator: PropTypes.string,
  index: PropTypes.number,
  isLastIndex: PropTypes.bool,
};

ArticleInfo.propTypes = {
  articleAuthor: PropTypes.object,
  publishDate: PropTypes.string,
  readingTime: PropTypes.number,
  articleInfoType: PropTypes.string,
};

export default ArticleInfo;
